<div class="d-flex flex-row flex-wrap align-items-center mt-2 mb-2">
  <div class="mr-2">{{ accountIdDisplay }}</div>
  <div class="d-flex flex-row">
    <div>
      <button
        id="move-date-backward-btn"
        nf-icon-button
        icon="chevron-left"
        ngbTooltip="Move date backward one day"
        (click)="onMoveDateBackward()"
      >
        Label
      </button>
    </div>
    <div style="min-width: 125px; width: 125px; height: 1rem">
      <nf-form-control compact>
        <nf-datepicker
          [formControl]="dateControl"
          [max]="maxDate"
          [min]="minDate"
        >
        </nf-datepicker>
      </nf-form-control>
    </div>
    <div class="mr-3">
      <button
        id="move-date-forward-btn"
        nf-icon-button
        icon="chevron-right"
        ngbTooltip="Move date forward one day"
        (click)="onMoveDateForward()"
      >
        Label
      </button>
    </div>
  </div>
  <div class="mr-3">
    <button id="prior-btn" nf-button (click)="onPriorClicked()">Prior</button>
  </div>
  <div class="mr-3">
    <button id="today-btn" nf-button (click)="onTodayClicked()">Today</button>
  </div>
</div>
